
/**
 * Module dependencies.
 */

import { Icon } from 'react-components/media';
import { color, media } from 'react-components/styles';
import { theme } from 'styled-tools';
import { useBreakpoint } from 'slyk-web-libs/breakpoint';
import React from 'react';
import noImage32Icon from 'client/assets/svg/32/no-image.svg';
import noImage72Icon from 'client/assets/svg/72/no-image.svg';
import styled from 'styled-components';

/**
 * `ProductIconWrapper` styled component.
 */

const ProductIconWrapper = styled.div`
  align-items: center;
  aspect-ratio: 3 / 4;
  background-color: ${color('gray300')};
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgba(25, 28, 30, 0.07);
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  transition: background-color ${theme('animations.defaultTransition')};

  ${media.min('ms')`
    background-color: ${color('gray200')};
  `}
`;

/**
 * `ProductNameLine` styled component.
 */

const ProductNameLine = styled.div`
  background-color: ${color('gray300')};
  border-radius: 2px;
  height: 13px;
  margin-bottom: 8px;
  transition: background-color ${theme('animations.defaultTransition')};
  width: 100%;

  ${media.min('ms')`
    background-color: ${color('gray200')};
  `}
`;

/**
 * `ProductAmountLine` styled component.
 */

const ProductAmountLine = styled.div`
  background-color: ${color('gray300')};
  border-radius: 2px;
  height: 13px;
  transition: background-color ${theme('animations.defaultTransition')};
  width: 35%;

  ${media.min('ms')`
    background-color: ${color('gray200')};
  `}
`;

/**
 * Export `DefaultProductItem` component.
 */

export function DefaultProductItem(): JSX.Element {
  const isDesktop = useBreakpoint('xl', 'min');

  return (
    <>
      <ProductIconWrapper>
        <Icon
          aria-hidden
          color={isDesktop ? color('gray500') : color('gray400')}
          icon={isDesktop ? noImage72Icon : noImage32Icon}
          size={isDesktop ? '72px' : '32px'}
        />
      </ProductIconWrapper>

      <ProductNameLine />

      <ProductAmountLine />
    </>
  );
}
